<template>
  <div class="monster-page-loading-model" v-if="isShow">
      <div class="monster-page-loading">
        <div class="monster-logo">
            <div class="logo-head"></div>
            <div class="logo-body">
                <div class="toaster-face">
                <div class="toaster-face-happy">
                    <div class="toaster-eyes-box">
                    <div class="toaster-eyes-happy toaster-eyes-happy--left"></div>
                    <div class="toaster-eyes-happy toaster-eyes-happy--right"></div>
                    </div>
                    <div class="logo-mouth">
                    <!-- <div class="logo-tooth"></div> -->
                    <div class="loader">
                        <div>{{loadingText}}</div>
                    </div>
                    </div>
                </div>
                <div class="toaster-face-tense">
                    <div class="toaster-eyes-tense-wr">
                    <div class="toaster-eyes-tense toaster-eyes-tense--left"></div>
                    <div class="toaster-eyes-tense toaster-eyes-tense--right"></div>
                    </div>
                    <div class="logo-mouth">
                    <div class="logo-tooth"></div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EbLoading',
  data () {
    return {
      isShow: false,
      loadingText: 'LOADING...'
    }
  },
  methods: {
    //   handleCloseLoading() {
    //       this.isShow = false
    //   }
  }
}
</script>

<style lang="scss" scoped>
    @import "./loading.scss";
</style>
